import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VokPlugin from '@finestmedia/vok'

// Vuetify
import 'vuetify/styles'
import './main.css'
import '@mdi/font/css/materialdesignicons.css'
import '@finestmedia/vok/dist/index.css'

import { KeskkonnaMuutujad } from './core/keskkonnamuutujad'
import { createPinia } from 'pinia'
import piniaPluginPersistedState from "pinia-plugin-persistedstate"
import { KasutajaTeenus } from './core/kasutaja-teenus'
import providerKeys from './providerKeys'
import { i18n } from '@/plugins/i18n'
import { vuetify } from '@/plugins/vuetify'

const pinia = createPinia();
pinia.use(piniaPluginPersistedState)
const kasutajaTeenus = new KasutajaTeenus();

const app = createApp(App)
  .use(vuetify)
  .use(router)
  .use(pinia)
  .use(i18n)
  .use(VokPlugin, { KuupaevaFormaat: KeskkonnaMuutujad.kuupaevFormaat })
  .provide(providerKeys.kasutajaTeenus, kasutajaTeenus);

app.mount('#app');
